import LinkSizable from '../link-sizable/LinkSizable';
import styles from './rounded-button-link-secondary.module.less';

const RoundedButtonLinkSecondary = ({ className = '', children, buttonRef, ...restProps }) => (
    <LinkSizable className={[styles.buttonLink, className].join(' ')} {...restProps} ref={buttonRef}>
        {children}
    </LinkSizable>
);

export default RoundedButtonLinkSecondary;
